import validateMilitary from "@aihCustomBlueprint/Handlers/ValidateMilitary";
import { AihAddAccountParameter } from "@aihCustomBlueprint/Overrides/Widgets/CreateAccount/CreateAccount";
import { getCookie, removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { redirectTo } from "@insite/client-framework/ServerSideRendering";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { FC, useContext, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    validateMilitary,
    addAccount,
};

const mapStateToProps = (state: ApplicationState) => ({
    location: getLocation(state),
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MilitaryAccountViewStyles {}

export const militaryAccountViewStyles: MilitaryAccountViewStyles = {};

const styles = militaryAccountViewStyles;

const MilitaryAccountView: FC<Props> = ({
    validateMilitary,
    addAccount,
    location,
}) => {
    const toasterContext = useContext(ToasterContext);

    useEffect(() => {
        const handleCallback = () => {
            const params = new URLSearchParams(location.search);
            const code = params.get("code");

            if (code) {
                validateMilitary({
                    code,
                    onSuccess: createMilitaryAccount,
                    onError: validateMilitaryCodeFailed,
                });
            } else {
                validateMilitaryCodeFailed("Something went wrong. Please try again later.");
            }
        };

        handleCallback();
    }, [location]);

    const getMilitaryAccountParameter = () => {
        let metaData;
        const insiteAccountMetadata = getCookie("InsiteAccountMetadata");
        if (insiteAccountMetadata !== undefined) {
            const decodedValue = decodeURIComponent(insiteAccountMetadata);
            metaData = JSON.parse(decodedValue);
        }
        const password = getCookie("Insitepw") as string;
        const militaryAccountParameter: AihAddAccountParameter = {
            email: metaData.email,
            userName: metaData.email,
            password,
            isSubscribed: metaData.isSubscribed,
            phone: metaData.phone,
            name: metaData.name,
            promos: metaData.promos,
            militaryStatus: metaData.militaryStatus,
            state: metaData.state,
            postCode: metaData.postCode,
            address1: metaData.address1,
            address2: metaData.address2,
            city: metaData.city,
            uri: "",
            properties: {
                MilitaryStatus: metaData.militaryStatus,
                phone: metaData.phone,
                name: metaData.name,
                state: metaData.state,
                postCode: metaData.postCode,
                city: metaData.city,
                address1: metaData.address1,
                address2: metaData.address2,
                addressValidated: metaData.addressValidated,
            },
        };
        return militaryAccountParameter;
    };

    const createMilitaryAccount = (responseVerified: any) => {
        const addAccountParam = getMilitaryAccountParameter();
        addAccount({
            ...addAccountParam,
            onError: validateMilitaryCodeFailed,
            onComplete(resultProps) {
                if (resultProps.apiResult?.successful) {
                    createAlaskaAccountCompleted(resultProps?.apiResult?.result);
                } else if (resultProps.apiResult?.errorMessage) {
                    this.onError?.(resultProps.apiResult.errorMessage);
                }
            },
        });
    };

    const createAlaskaAccountCompleted = (updatedAccount: AccountModel) => {
        const expires = new Date(new Date().getTime() + 20 * 7 * 24 * 60 * 60 * 1000); // 20 weeks
        setCookie("IDMEStatus", "OK", { expires, path: "/" });
        console.log("IDMEStatus: OK set to cookie. Closing the window...");
        removeCookie("Insitepw");
        window.close();
    };

    const validateMilitaryCodeFailed = (msg: any) => {
        toasterContext.addToast({ body: translate(msg), messageType: "danger" });
        const expires = new Date(new Date().getTime() + 20 * 7 * 24 * 60 * 60 * 1000); // 20 weeks
        setCookie("IDMEStatus", "Err", { expires, path: "/" });
        redirectTo("/");
    };

    return (
        <div>
            <h2>Verifying your ID...</h2>
        </div>
    );
};

const militaryAccountViewWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MilitaryAccountView),
    definition: {
        displayName: "Military Validation",
        group: "My Account",
    },
};

export default militaryAccountViewWidget;
